var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRssSquare = function SvgRssSquare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A1AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M11.667 11.667a16.667 16.667 0 0 1 16.666 16.666m-16.666-8.772a8.772 8.772 0 0 1 8.772 8.772m-8.345-.438h.011M18.333 35h3.334c4.667 0 7 0 8.783-.908a8.333 8.333 0 0 0 3.642-3.642C35 28.667 35 26.334 35 21.667v-3.334c0-4.667 0-7-.908-8.783a8.333 8.333 0 0 0-3.642-3.642C28.667 5 26.334 5 21.667 5h-3.334c-4.667 0-7 0-8.783.908A8.333 8.333 0 0 0 5.908 9.55C5 11.333 5 13.666 5 18.333v3.334c0 4.667 0 7 .908 8.783a8.333 8.333 0 0 0 3.642 3.642c1.783.908 4.116.908 8.783.908Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRssSquare);
export default ForwardRef;